import isOptimizelyFeatureEnabled from "../../../../../optimizely/utils/isOptimizelyFeatureEnabled";

const glutenFreeLink = 'https://www.pizzahut.com/index.php?gluten-free=#/gluten-free';
const oldCauliflowerCrustLink = 'https://www.pizzahut.com/c/content/califlour-pizza-crust';
const cauliflowerCrustLink = 'https://www.pizzahut.com/c/content/cauliflower-pizza-crust';
// ['Cauliflower Pepperoni', 'Cauliflower Cheese Pizza', 'Cauliflower Crust']
const cauliflowerCrustPizzas = ['CLSS001P|PROD554CA', 'CLSS001P|PROD553CC', 'CLSS001P|BASE600CC']; 

export const glutenFreeDetails = (id: string): ModalContent => {
  const cauliFlowerCrustLinkInModal = isOptimizelyFeatureEnabled('fr-web-4677-cauliflower-modal-url') ? cauliflowerCrustLink : oldCauliflowerCrustLink;
  const linkUrl = cauliflowerCrustPizzas.includes(id) ? cauliFlowerCrustLinkInModal : glutenFreeLink;

  return {
    body: 'Pizza Hut kitchens are not gluten-free environments. We cannot guarantee that our restaurant environment or any menu item will be completely free of gluten.',
    title: 'Gluten-free crust',
    cta: {
      text: 'GOT IT'
    },
    link: {
      linkUrl,
      linkDisplayText: 'More Details',
      linkIcon: true,
      linkTestId: 'gluten-free-more-details',
      target: '_blank'
    },
    hideCloseIcon: true
  }
};

